import { createContext } from 'react';
import { CaUser } from './types';

export const CaUserContext = createContext<{
  user: CaUser;
  clearUser: () => void;
  isLoading: boolean;
}>({
  user: null,
  clearUser: () => {
    throw new Error('clearUser must be used within CaUserProvider');
  },
  isLoading: false,
});
